import { render, staticRenderFns } from "./webhook-failed.vue?vue&type=template&id=bd9ee3e4&"
import script from "./webhook-failed.vue?vue&type=script&lang=js&"
export * from "./webhook-failed.vue?vue&type=script&lang=js&"
import style0 from "./webhook-failed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports